export default "__VITE_ASSET__bf0f9419__"